import Button from "components/atoms/Button/Button";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
/**
 * Access Denied page - when user is not authorized to access a page.
 */
const AccessDenied = function () {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <Row>
      <Col md={12}>
        <h1 className="mb-4">
          <FormattedMessage id="general.accessDenied" defaultMessage="Access Denied" />
        </h1>
        <p>
          <FormattedMessage
            id="accessDenied.dontHavePermissionToViewPage"
            defaultMessage="You do not have permission to view this page."
          />
        </p>
        <Button
          label={intl.formatMessage({
            id: "general.back",
            defaultMessage: "Back",
          })}
          className="mt-4"
          onClick={() => {
            navigate(-2);
          }}
        />
      </Col>
    </Row>
  );
};

export default AccessDenied;
